import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _AssetItemsByOperationState, _FixedAssetItem } from '../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../theme/Component/usePaginator';
import { Modal } from '../../theme/Component/Modal';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { _RequestMaintenance } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    label?: string;
    idSelector: number;
    onChange?: any;
    renderMachine?: string;
    filters?: any;
}

export const EditorFixedAssetItemByFilters = ({ idSelector, label, onChange, renderMachine, filters }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_RequestMaintenance);
    const paginador = usePaginator();

    const [form, setform] = useState<any>({})

    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (renderMachine) {
            setRenderValue(renderMachine);
        }
    }, [renderMachine])

    useEffect(() => {
        if (filters) {
            getLista();
        }
    }, [paginador.page])

    useEffect(() => {
        if (idSelector) {

        } else {
            setBean({});
            onChange({})
        }
    }, [idSelector])

    const getLista = () => {
        let Props: any = {}

        if (filters) Props = { ...Props, ...filters }

        instance.getFixedAssetItemsMaintenablesRender(paginador.page, 15, Props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                if (resp.List) {
                    resp.List.forEach(element => {
                        const item = element.DataBeanProperties;
                        item.AssetEntity = item.IDFixedAsset ? `${item.IDFixedAsset} - ${item.AssetName}` : "N/A";
                        item.ResponsibleEntity = item.IDAccount ? `${item.AccountNit ?? ""} - ${item.AccountEntity ?? ""}` : "N/P";
                        item.DocumentEntity = item.IDDocument ? `${item.Mnemonic} - ${item.Consecutive}` : "N/A";
                        item.WeigthEntity = item.WeightMeasurementUnit ? `${item.WeightName ?? "N/P"} - ${item.DimWeight ?? "N/P"}` : "N/A";
                        item.LengthEntity = item.LengthMeasurementUnit ? `${item.LengthName ?? "N/P"} - ${item.DimWidth ?? "N/P"} x ${item.DimHeigth}` : "N/A";
                    });
                    setLista(resp.List)
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const [renderValue, setRenderValue] = useState<string>("");

    const head = [
        { title: 'ID', property: 'IDItem', visible: true, MASK: MASK_NUMBER },
        { title: 'Codigo Interno', property: 'InternalCode', visible: true },
        { title: 'Nombre', property: 'AssetEntity', visible: true },
        { title: 'Responsable', property: 'ResponsibleEntity', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Almacen', property: 'StoreName', visible: true },
        { title: 'Ubicación', property: 'SiteName', visible: true },
        { title: 'Modelo Operativo', property: 'SupplierModel', visible: true },
        { title: 'Dimensiones', property: 'LengthEntity', visible: true },
        { title: 'Peso', property: 'WeigthEntity', visible: true },
        { title: 'Area de Mantenimiento', property: 'MaintenanceName', visible: true },
    ]

    const selectItem = () => {
        if (bean.IDItem) {
            setRenderValue(`${bean.IDItem}-${bean.AssetEntity}`)
            setModal({ ...modal, view: false });
            onChange?.(bean)
        } else {
            toast.error("Objeto no valido")
        }
    }

    return (
        <>
            {label && label != " " &&
                < label > {label ?? "Item/Placas de Activos Fijos"}</label>
            }
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { setModal({ ...modal, "view": true }) }}
            />

            <Modal modal={modal} updateModal={setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable
                            body={lista}
                            head={head}
                            rowSet={setBean}
                            pageTop={paginador.page}
                            next={paginador.next}
                            back={paginador.back}
                            records={paginador}
                            customRows={15}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
}
